import { Link } from 'react-router-dom';

export default function MarketingFooter() {
  return (
    <footer className="bg-[#0A2540] text-white">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img src="/favicon-32.png" alt="Scrivera" className="w-6 h-6" />
              <span className="font-bold text-lg">Scrivera</span>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed">
              The AI platform that listens, documents, and operates African healthcare — from clinic to continent.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-4">Platform</h3>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/features" className="hover:text-[#06B6D4] transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="hover:text-[#06B6D4] transition-colors">Pricing</Link></li>
              <li><Link to="/about" className="hover:text-[#06B6D4] transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-[#06B6D4] transition-colors">Contact</Link></li>
              <li><Link to="/app/login" className="hover:text-[#06B6D4] transition-colors">Sign In</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-4">Contact</h3>
            <ul className="space-y-2 text-sm text-slate-300">
              <li>scriverahealth.com</li>
              <li className="pt-4 text-xs text-slate-400">Incubated by Darrel Technologies Ltd</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-slate-700 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} Scrivera · Darrel Technologies Ltd. All rights reserved.</p>
          <p>Offline-capable · On-premise · Multilingual</p>
        </div>
      </div>
    </footer>
  );
}
